package com.mgacreative.hotelru

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.CanvasBasedWindow
import kotlinx.browser.window
import org.jetbrains.skiko.wasm.onWasmReady
import org.koin.compose.KoinContext
import org.koin.core.context.startKoin

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        console.log("Skiko WASM is ready. Starting HotelOS WebApp...")

        // Hide HTML loading overlay once WASM is ready
        window.document.getElementById("loading-overlay")?.asDynamic()?.style?.display = "none"

        // Auto-create canvas if missing in DOM
        if (window.document.getElementById("ComposeTarget") == null) {
            val newCanvas = window.document.createElement("canvas")
            newCanvas.id = "ComposeTarget"
            window.document.body?.appendChild(newCanvas)
        }

        try {
            startKoin {
                modules(getWebAppModules())
            }
            console.log("Koin modules initialized successfully.")
        } catch (e: Throwable) {
            console.warn("Koin notice: ${e.message}")
        }

        try {
            CanvasBasedWindow(title = "HotelOS", canvasElementId = "ComposeTarget") {
                KoinContext {
                    WebApp()
                }
            }
            console.log("CanvasBasedWindow mounted successfully.")
        } catch (e: Throwable) {
            console.error("CanvasBasedWindow initialization error:", e.message, e.asDynamic().stack)
        }
    }
}
